import { AxiosError } from "axios"

export interface SohoApiError {
  code: number
  error: string
  url?: string
  trace?: string
}

function extractAxiosError (E: AxiosError): SohoApiError {
  if (E.response) {
    const error = E.response.data && E.response.data.errors ? E.response.data.errors : E.response.data
    return {
      code: E.response.status,
      url: E.config.url,
      error: JSON.stringify(error),
      trace: E.stack
    }
  }

  return {
    code: 0,
    url: E.config && E.config.url,
    error: E.message || 'Request failed before response',
    trace: E.stack
  }
}

export default extractAxiosError
